import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getInteractions } from 'src/redux/tagging/selectors';
import { incrementInteractions } from 'src/redux/tagging/actions';
import * as events from './dataLayer/events';
import useResolver from './dataLayer/resolver';

const useDataLayer = () => {
  const resolver = useResolver();
  const dispatch = useDispatch();
  const interactions = useSelector(getInteractions);

  const interactionVariableMappings = {
    configuratorTotalActions: 'total',
    configuratorColourActions: 'colours',
    configuratorAccessoryActions: 'accessories',
    configuratorPackActions: 'packs',
    configuratorExtrasActions: 'extras',
  };

  const incrementEvents = {
    configuratorAccessorySelected: ['configuratorAccessoryActions', 'configuratorTotalActions'],
    configuratorAccessoryRemoved: ['configuratorAccessoryActions', 'configuratorTotalActions'],
    configuratorColourSelected: ['configuratorColourActions', 'configuratorTotalActions'],
    configuratorPackSelected: ['configuratorPackActions', 'configuratorTotalActions'],
    configuratorPackRemoved: ['configuratorTotalActions'],
    configuratorAccessoryConflict: ['configuratorAccessoryActions', 'configuratorTotalActions'],
    configuratorExtraSelected: ['configuratorExtrasActions', 'configuratorTotalActions'],
    configuratorExtraRemoved: ['configuratorExtrasActions', 'configuratorTotalActions'],
  };

  return (eventName, overrides = {}) => {
    const eventDataVariables = events[eventName]; // eslint-disable-line

    const dataLayerObj = eventDataVariables.reduce(
      (prevDataLayerObj, dataLayerVariable) => {
        const interaction = interactionVariableMappings[dataLayerVariable];
        const needsIncrement = incrementEvents[eventName] && interaction;

        if (needsIncrement) {
          dispatch(incrementInteractions(interaction));
        }

        const currentCount = interactions[interaction];
        const newCount = needsIncrement ? currentCount + 1 : currentCount;

        return {
          ...prevDataLayerObj,
          [dataLayerVariable]: interaction ? newCount : resolver[dataLayerVariable] && resolver[dataLayerVariable](),
          ...overrides,
        };
      },
      {
        event: eventName,
      }
    );

    const isGa = !!document.querySelector('script[id="ga"]');

    if (isGa) {
      if (!window?.gtag) {
        return;
      }

      window.gtag('event', `${dataLayerObj.event}`, dataLayerObj);
    } else {
      if (!window.dataLayer) {
        return;
      }

      window.dataLayer.push(dataLayerObj);
    }
  };
};

export default useDataLayer;
